// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AcceptCookieModal_wrap__mhISy","text":"AcceptCookieModal_text__UY8iw","accent":"AcceptCookieModal_accent__OgGX6"};